
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexjMzAo9_45f88vFzsOxITKdBu5hUuR42wVXSOkVFQSmNVgMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/index.vue?macro=true";
import { default as _91id_93Y8cy08BKuisk_XFQ1qLQaub0Gdje5btsLgjDuJe8zvkMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/manager/adjusters/[id].vue?macro=true";
import { default as add2hoHlbHh1gr6hLFOLAIia3eq5bOcMmQPh_nhmmN_Z20Meta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/manager/adjusters/add.vue?macro=true";
import { default as index5C1RNGhI0JZtDqnheZSOZB_Jokh4xEKHH06ZgqEMt5UMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/manager/adjusters/index.vue?macro=true";
import { default as adjustersJMZDXjP_45OTthi0oFYbwFmqsnDjLu6aZdS8TuDL_gCsUMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/manager/adjusters.vue?macro=true";
import { default as editd1_IOPFjx2sBd7wgPHis2yCV57OPsdwoNgNoJZ3iSFsMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/manager/customers/[id]/edit.vue?macro=true";
import { default as indexow_Kn05nQnny_YierYen8G57njAcj6aUpZlAwanq748Meta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/manager/customers/[id]/index.vue?macro=true";
import { default as add1CVJE7xRepXWti5aVv_7lXn1A3lOnbrkY5D7OECfoFUMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/manager/customers/add.vue?macro=true";
import { default as index1lJd88FsHmv8czsZXXQfFA5KxpPmhs9d_hRv8EBkQI4Meta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/manager/customers/index.vue?macro=true";
import { default as index_45_yzV34tCGSNB162iVBZDgyHyzle4dAtRdi7QQE9o1UMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/manager/index.vue?macro=true";
import { default as editRDPivR5ly5FCu7H_45KFx4ZrtDvwxPhgZc_45Z6bzdThsGsMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/manager/projects/[id]/edit.vue?macro=true";
import { default as indexGXbrP_DnE8KZ10vxTz37gqodo5jNQUFKv3Cl99cSn6IMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/manager/projects/[id]/index.vue?macro=true";
import { default as addVFqo9zLF1bVmnQ_12_454YwQSrqIyx45RwPNkNHfXsVikMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/manager/projects/add.vue?macro=true";
import { default as indexHE_xEnuG32FAmytgR37RTdpzLDU_45PNk96zlSyT0IUdsMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/manager/projects/index.vue?macro=true";
import { default as tasks4e2MHEtunHszcWdMUon8kgFg38RGEbtxgzQeQcX4BfMMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/manager/tasks.vue?macro=true";
import { default as to_45collectNllLOhTHoEtw9_RacTKX28UnTnBwIB4KfWfPUvxmO7sMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/manager/to-collect.vue?macro=true";
import { default as notificationspOd9OCl5ELzEF3keGa616tNR7NtcpysPZ3NVsop9r6gMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/notifications.vue?macro=true";
import { default as indexce_0Q1U2Vs_101SCUeTUYFTcEbhonfr22kSE3DJc_NYMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/scheduling/index.vue?macro=true";
import { default as projectssERuA6rdXGyRmO3rlGMFr57Jt8H9UqRl53h6_VuvDoAMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/scheduling/projects.vue?macro=true";
import { default as tasks_XDAfjajk0wBfwQ3ttftpLoCI_hO_lWdMGJ2kupSdIwMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/scheduling/tasks.vue?macro=true";
import { default as editeGspymJ6LVZsjN6ZMwIXeLO7Oi6g00cdAgwOrvY53HgMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/bill-types/[id]/edit.vue?macro=true";
import { default as index9S2bFxp7lmRhUc0JBQirB6agjzBdlM4ZPORoqmZ0nWEMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/bill-types/[id]/index.vue?macro=true";
import { default as _91id_930_AxZr_45Zms55zAlsSbUnZndfp4WPLW5waDAh664VZRwMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/bill-types/[id].vue?macro=true";
import { default as addS_45i8yiK71i7zNabw6x7y_l075dYxGrPiHSgRPsgVyK8Meta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/bill-types/add.vue?macro=true";
import { default as indexwvMi3_45htDGtmsN4uKJreOm0ucHHW5AkR_og3QsCwdmIMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/bill-types/index.vue?macro=true";
import { default as _91id_93FmMnTsZyF0MwKr_45jQbL6vwhuIVvVNX2IrUJ_45AHKo2WoMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/crews/[id].vue?macro=true";
import { default as addt0vTNSYdaeww1cJjZqHUfgVM4Lp07eJPc9OhHSKuDoMMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/crews/add.vue?macro=true";
import { default as indexVfdUOr9_VFb5YKnlDimVRB_UyujM7oW2_5csXMzNrhwMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/crews/index.vue?macro=true";
import { default as crewsfUhKVnJr1Qoiveu_yE5olyfAzi8eqfRuQxfIVSYoFdkMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/crews.vue?macro=true";
import { default as edit847rELtwkjHj7ouhgSwwkhHRHHUBB8o3feAB7mlKqZUMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/edit.vue?macro=true";
import { default as indexhrLPBR2Q_q1k_6eN2_o6j_453wu0QvNAofLUQR2ArOxiYMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/index.vue?macro=true";
import { default as _91id_937QaQGPez21I9ZbkHiLUNqZxy8Lzjko8isHnTOlr_7CEMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/insurance-companies/[id].vue?macro=true";
import { default as addDZ9Y7s6q6cNZcH_45KDik5UNIDrabEFvL7f_45uNhekXQ68Meta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/insurance-companies/add.vue?macro=true";
import { default as index88sIfO0f0IcG6vKQ25kSRlMBV8Kc__45IkfAyy3o56LUAMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/insurance-companies/index.vue?macro=true";
import { default as insurance_45companiesl_45vkeCyfzM68TcpZfdkVi9F6_Lr_MbPwfKgEOYzLzdwMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/insurance-companies.vue?macro=true";
import { default as editDUtIr6yyDcss3IIl9Z9tujOfM07isIENUwY7aAGImjMMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/job-types/[id]/edit.vue?macro=true";
import { default as index__yKmTSluKQJVimZHwXQAHIYqunz4i47svlqDhOgMX8Meta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/job-types/[id]/index.vue?macro=true";
import { default as _91id_93BSdOfs6qOG3DtnYpmckt0UVRL8n7EHeZ2CyMQz5ta_45cMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/job-types/[id].vue?macro=true";
import { default as add5Msnq8ZY48YfVHdfa_ois03WpT91Y9dNPpR65o93_45KkMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/job-types/add.vue?macro=true";
import { default as indexODxESvrOmNvvvluKVhMAfQSe2i4Oca4xIUCbM1cT6R0Meta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/job-types/index.vue?macro=true";
import { default as _91id_93SmpZClq1rWY3DeUGflXbbAPz7HSjbzYGCFA_45NCGB_2gMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/tabs/[id].vue?macro=true";
import { default as addSbTTYosX6JiZLg00mBYfnd6qsx5q1HNPUvZiL4kCF14Meta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/tabs/add.vue?macro=true";
import { default as indexblOXtTPeGvGO1l0J8n8XfTDEzTLJ3QeVpBFJXKwJx_45gMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/tabs/index.vue?macro=true";
import { default as tabs2WbXUFKf2V_rfjnk9Yph64tfeHMRWYO0HEdJzCYpRKMMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/tabs.vue?macro=true";
import { default as _91id_93UFx4eg1dekoWS_45NjNYg4V9joF_SBOr5Gy8zi2LRS19wMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/templates/[id].vue?macro=true";
import { default as add2TzYS4Li44GFSu4VtZBJJ6rEZ0r58lBVE6J1d_45__WNoMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/templates/add.vue?macro=true";
import { default as templatesx_eT481mnhg2gLpV_kKSAW0TB1aAXbwg9kyddjuqCvQMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/templates.vue?macro=true";
import { default as _91id_93f_Cd4yzHWCCCMOiKmQo19duoMlzy2n2tVZtpuwZhQ9YMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/users/[id].vue?macro=true";
import { default as addRMM8UR2XJDDCOzpkeU3aEF2PxyN39ADb8BdJwq3qpdQMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/users/add.vue?macro=true";
import { default as indexd9R_453L4snRBC9Iyxr2oR08jo_SD10wafVpayCBbFHb0Meta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/users/index.vue?macro=true";
import { default as users0wuDOV9GHgk51ceaOjpjkGEkZES6xPm3MnTvIXdqBuoMeta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId]/users.vue?macro=true";
import { default as _91organizationId_9399NjKaGDFE4CipnniQZ1W4mKwDhMRylR5V3kp4V82p0Meta } from "/home/runner/work/classical/classical/frontend/pages/[organizationId].vue?macro=true";
import { default as indext8fR2PvIMPfz2ZLTr1_45mg_45bOU9mrAKcpZFeF1_beonsMeta } from "/home/runner/work/classical/classical/frontend/pages/account/index.vue?macro=true";
import { default as loginmHgoR9omvGT9UgQ1MMO9l4Goj3gth2JBxgUu_45YfBJbwMeta } from "/home/runner/work/classical/classical/frontend/pages/account/login.vue?macro=true";
import { default as _91token_93UTYfOQlOZTDksjcp9xxxQY1778tE5uyz80aDfAkp4kYMeta } from "/home/runner/work/classical/classical/frontend/pages/account/password-reset/[uidb64]/[token].vue?macro=true";
import { default as completeVMQixElcX2Kl2oIORxFl4flDCr2gRo4uCRepn74D6gkMeta } from "/home/runner/work/classical/classical/frontend/pages/account/password-reset/complete.vue?macro=true";
import { default as done5OkuFTIrjmFS5WpnrS5Rvv9YDNtTcr8QE9hCMvoq944Meta } from "/home/runner/work/classical/classical/frontend/pages/account/password-reset/done.vue?macro=true";
import { default as indexj0pAed_45Oki5t1PomyovrsdSkK65IP97c8M6rr4_L6JMMeta } from "/home/runner/work/classical/classical/frontend/pages/account/password-reset/index.vue?macro=true";
import { default as password_45reseteKvQ08hR0Es_tbzk16o0v_SYnTAVevFsblRlfqmh_45vsMeta } from "/home/runner/work/classical/classical/frontend/pages/account/password-reset.vue?macro=true";
import { default as signuptKFsw3qcoPt0WQ5XwOI16MWFGp4h_45zFAqAUPdOU_454K0Meta } from "/home/runner/work/classical/classical/frontend/pages/account/signup.vue?macro=true";
import { default as indexmlYrOsxbZN3p0UKB3RH1I8O2wZBZiZPDIT7NW80jFHkMeta } from "/home/runner/work/classical/classical/frontend/pages/index.vue?macro=true";
export default [
  {
    name: _91organizationId_9399NjKaGDFE4CipnniQZ1W4mKwDhMRylR5V3kp4V82p0Meta?.name,
    path: "/:organizationId()",
    meta: _91organizationId_9399NjKaGDFE4CipnniQZ1W4mKwDhMRylR5V3kp4V82p0Meta || {},
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId].vue"),
    children: [
  {
    name: "organizationId",
    path: "",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/index.vue")
  },
  {
    name: adjustersJMZDXjP_45OTthi0oFYbwFmqsnDjLu6aZdS8TuDL_gCsUMeta?.name,
    path: "manager/adjusters",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/manager/adjusters.vue"),
    children: [
  {
    name: "organizationId-manager-adjusters-id",
    path: ":id()",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/manager/adjusters/[id].vue")
  },
  {
    name: "organizationId-manager-adjusters-add",
    path: "add",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/manager/adjusters/add.vue")
  },
  {
    name: "organizationId-manager-adjusters",
    path: "",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/manager/adjusters/index.vue")
  }
]
  },
  {
    name: "organizationId-manager-customers-id-edit",
    path: "manager/customers/:id()/edit",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/manager/customers/[id]/edit.vue")
  },
  {
    name: "organizationId-manager-customers-id",
    path: "manager/customers/:id()",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/manager/customers/[id]/index.vue")
  },
  {
    name: "organizationId-manager-customers-add",
    path: "manager/customers/add",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/manager/customers/add.vue")
  },
  {
    name: "organizationId-manager-customers",
    path: "manager/customers",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/manager/customers/index.vue")
  },
  {
    name: "organizationId-manager",
    path: "manager",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/manager/index.vue")
  },
  {
    name: "organizationId-manager-projects-id-edit",
    path: "manager/projects/:id()/edit",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/manager/projects/[id]/edit.vue")
  },
  {
    name: "organizationId-manager-projects-id",
    path: "manager/projects/:id()",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/manager/projects/[id]/index.vue")
  },
  {
    name: "organizationId-manager-projects-add",
    path: "manager/projects/add",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/manager/projects/add.vue")
  },
  {
    name: "organizationId-manager-projects",
    path: "manager/projects",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/manager/projects/index.vue")
  },
  {
    name: "organizationId-manager-tasks",
    path: "manager/tasks",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/manager/tasks.vue")
  },
  {
    name: "organizationId-manager-to-collect",
    path: "manager/to-collect",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/manager/to-collect.vue")
  },
  {
    name: "organizationId-notifications",
    path: "notifications",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/notifications.vue")
  },
  {
    name: "organizationId-scheduling",
    path: "scheduling",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/scheduling/index.vue")
  },
  {
    name: "organizationId-scheduling-projects",
    path: "scheduling/projects",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/scheduling/projects.vue")
  },
  {
    name: "organizationId-scheduling-tasks",
    path: "scheduling/tasks",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/scheduling/tasks.vue")
  },
  {
    name: _91id_930_AxZr_45Zms55zAlsSbUnZndfp4WPLW5waDAh664VZRwMeta?.name,
    path: "setup/bill-types/:id()",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/bill-types/[id].vue"),
    children: [
  {
    name: "organizationId-setup-bill-types-id-edit",
    path: "edit",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/bill-types/[id]/edit.vue")
  },
  {
    name: "organizationId-setup-bill-types-id",
    path: "",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/bill-types/[id]/index.vue")
  }
]
  },
  {
    name: "organizationId-setup-bill-types-add",
    path: "setup/bill-types/add",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/bill-types/add.vue")
  },
  {
    name: "organizationId-setup-bill-types",
    path: "setup/bill-types",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/bill-types/index.vue")
  },
  {
    name: crewsfUhKVnJr1Qoiveu_yE5olyfAzi8eqfRuQxfIVSYoFdkMeta?.name,
    path: "setup/crews",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/crews.vue"),
    children: [
  {
    name: "organizationId-setup-crews-id",
    path: ":id()",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/crews/[id].vue")
  },
  {
    name: "organizationId-setup-crews-add",
    path: "add",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/crews/add.vue")
  },
  {
    name: "organizationId-setup-crews",
    path: "",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/crews/index.vue")
  }
]
  },
  {
    name: "organizationId-setup-edit",
    path: "setup/edit",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/edit.vue")
  },
  {
    name: "organizationId-setup",
    path: "setup",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/index.vue")
  },
  {
    name: insurance_45companiesl_45vkeCyfzM68TcpZfdkVi9F6_Lr_MbPwfKgEOYzLzdwMeta?.name,
    path: "setup/insurance-companies",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/insurance-companies.vue"),
    children: [
  {
    name: "organizationId-setup-insurance-companies-id",
    path: ":id()",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/insurance-companies/[id].vue")
  },
  {
    name: "organizationId-setup-insurance-companies-add",
    path: "add",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/insurance-companies/add.vue")
  },
  {
    name: "organizationId-setup-insurance-companies",
    path: "",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/insurance-companies/index.vue")
  }
]
  },
  {
    name: _91id_93BSdOfs6qOG3DtnYpmckt0UVRL8n7EHeZ2CyMQz5ta_45cMeta?.name,
    path: "setup/job-types/:id()",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/job-types/[id].vue"),
    children: [
  {
    name: "organizationId-setup-job-types-id-edit",
    path: "edit",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/job-types/[id]/edit.vue")
  },
  {
    name: "organizationId-setup-job-types-id",
    path: "",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/job-types/[id]/index.vue")
  }
]
  },
  {
    name: "organizationId-setup-job-types-add",
    path: "setup/job-types/add",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/job-types/add.vue")
  },
  {
    name: "organizationId-setup-job-types",
    path: "setup/job-types",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/job-types/index.vue")
  },
  {
    name: tabs2WbXUFKf2V_rfjnk9Yph64tfeHMRWYO0HEdJzCYpRKMMeta?.name,
    path: "setup/tabs",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/tabs.vue"),
    children: [
  {
    name: "organizationId-setup-tabs-id",
    path: ":id()",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/tabs/[id].vue")
  },
  {
    name: "organizationId-setup-tabs-add",
    path: "add",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/tabs/add.vue")
  },
  {
    name: "organizationId-setup-tabs",
    path: "",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/tabs/index.vue")
  }
]
  },
  {
    name: "organizationId-setup-templates",
    path: "setup/templates",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/templates.vue"),
    children: [
  {
    name: "organizationId-setup-templates-id",
    path: ":id()",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/templates/[id].vue")
  },
  {
    name: "organizationId-setup-templates-add",
    path: "add",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/setup/templates/add.vue")
  }
]
  },
  {
    name: users0wuDOV9GHgk51ceaOjpjkGEkZES6xPm3MnTvIXdqBuoMeta?.name,
    path: "users",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/users.vue"),
    children: [
  {
    name: "organizationId-users-id",
    path: ":id()",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/users/[id].vue")
  },
  {
    name: "organizationId-users-add",
    path: "add",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/users/add.vue")
  },
  {
    name: "organizationId-users",
    path: "",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/[organizationId]/users/index.vue")
  }
]
  }
]
  },
  {
    name: "account",
    path: "/account",
    meta: indext8fR2PvIMPfz2ZLTr1_45mg_45bOU9mrAKcpZFeF1_beonsMeta || {},
    component: () => import("/home/runner/work/classical/classical/frontend/pages/account/index.vue")
  },
  {
    name: "account-login",
    path: "/account/login",
    meta: loginmHgoR9omvGT9UgQ1MMO9l4Goj3gth2JBxgUu_45YfBJbwMeta || {},
    component: () => import("/home/runner/work/classical/classical/frontend/pages/account/login.vue")
  },
  {
    name: password_45reseteKvQ08hR0Es_tbzk16o0v_SYnTAVevFsblRlfqmh_45vsMeta?.name,
    path: "/account/password-reset",
    meta: password_45reseteKvQ08hR0Es_tbzk16o0v_SYnTAVevFsblRlfqmh_45vsMeta || {},
    component: () => import("/home/runner/work/classical/classical/frontend/pages/account/password-reset.vue"),
    children: [
  {
    name: "account-password-reset-uidb64-token",
    path: ":uidb64()/:token()",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/account/password-reset/[uidb64]/[token].vue")
  },
  {
    name: "account-password-reset-complete",
    path: "complete",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/account/password-reset/complete.vue")
  },
  {
    name: "account-password-reset-done",
    path: "done",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/account/password-reset/done.vue")
  },
  {
    name: "account-password-reset",
    path: "",
    component: () => import("/home/runner/work/classical/classical/frontend/pages/account/password-reset/index.vue")
  }
]
  },
  {
    name: "account-signup",
    path: "/account/signup",
    meta: signuptKFsw3qcoPt0WQ5XwOI16MWFGp4h_45zFAqAUPdOU_454K0Meta || {},
    component: () => import("/home/runner/work/classical/classical/frontend/pages/account/signup.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexmlYrOsxbZN3p0UKB3RH1I8O2wZBZiZPDIT7NW80jFHkMeta || {},
    component: () => import("/home/runner/work/classical/classical/frontend/pages/index.vue")
  }
]